module.exports = __webpack_public_path__ + "static/media/Feb27-S18.ccf1242f.png";